import { forwardRef } from 'react';
import { Box } from '@material-ui/core';

import MetaProvider from 'layouts/MetaProvider';
import Footer from 'layouts/Footer';
import AppHeader from 'layouts/AppHeader';

const MainLayout = forwardRef((props, ref) => {
  const {
    children,
    nofooter,
    landing,
    loading,
    meta,
    pending,
    subheader,
    hideSearch,
    ...rest
  } = props;

  return (
    <MetaProvider meta={meta}>
      <Box ref={ref} {...rest}>
        <AppHeader
          pending={pending}
          hideSearch={hideSearch}
          loading={loading}
          landing={landing}
          subheader={subheader}
        >
          {children}

          {!nofooter && <Footer />}
        </AppHeader>
      </Box>
    </MetaProvider>
  );
});

export default MainLayout;
